import { render, staticRenderFns } from "./super-admin-tab.vue?vue&type=template&id=1761316c"
import script from "./super-admin-tab.vue?vue&type=script&lang=js"
export * from "./super-admin-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports